import { render, staticRenderFns } from "./AddSkillsCard.vue?vue&type=template&id=f1a68550&"
import script from "./AddSkillsCard.vue?vue&type=script&lang=js&"
export * from "./AddSkillsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports